export default "__VITE_ASSET__DyY1l1bS__"